export type OrderItemListMessages = {
  //Titles
  orderItemsTitle: string;

  //Labels
  itemSkuLabel: string;
  itemProductLabel: string;
  itemCommentLabel: string;
  itemQuantityLabel: string;
  itemPriceLabel: string;
  itemTotalLabel: string;
};

export const ORDER_ITEM_LIST: OrderItemListMessages = {
  //Titles
  orderItemsTitle: "Itens do Pedido",

  //Labels
  itemSkuLabel: "SKU",
  itemProductLabel: "Produto",
  itemCommentLabel: "Comentário",
  itemQuantityLabel: "Quantidade",
  itemPriceLabel: "Preço",
  itemTotalLabel: "Total",
};
